{
  "R": [0, 255, 255, 255],
  "G": [0, 0, 126, 255],
  "B": [0, 0, 0, 255],
  "A": [0, 64, 96, 128],
  "I": [0, 128, 191, 255]
}
